import React from "react";

/**
 * Function to display the text for the selected count.
 *
 * @param {number} selectedCount - the count of selected items
 * @return {JSX.Element | null} JSX element representing the text for the selected count, or null if selectedCount is falsy
 */
export const SelectedCountText = ({
  selectedCount,
  totalCount = 0,
  isSelectedAll = false,
  handleSelectAll = () => {},
  clearSelected = () => {},
  updateSelected = () => {},
  currentDataLength = 0,
  customText = "Record",
}) => {
  let unselectedCount = currentDataLength - selectedCount;
  if (selectedCount) {
    return (
      <div className="flex h-[40px] items-center gap-2">
        <span className="text-center text-[14px] font-semibold leading-[normal] text-txtColor">
          {isSelectedAll
            ? `${unselectedCount == 0 ? "All" : ""} ${totalCount - unselectedCount} ${totalCount - unselectedCount > 1 ? customText + "s" : customText}`
            : `${selectedCount} ${selectedCount > 1 ? customText + "s" : customText}`}{" "}
          Selected
        </span>
        {(totalCount > selectedCount &&
          selectedCount == currentDataLength &&
          currentDataLength > 8) ||
        isSelectedAll ? (
          <button
            className={`transition-linear rounded-lg px-3 py-2 text-[14px] font-semibold leading-[normal] text-primary hover:bg-lightblue`}
            type="button"
            onClick={() => {
              if (isSelectedAll) {
                updateSelected([]);
                clearSelected();
              }
              handleSelectAll(!isSelectedAll);
            }}
          >
            {isSelectedAll
              ? "Clear Selection"
              : `Select All ${totalCount} ${totalCount > 1 ? "Records" : "Record"}`}
          </button>
        ) : null}
      </div>
    );
  }
  return null;
};
